import type { RosterAdultMember } from '@appTypes/esb';
import type { OrgPositionDetail } from '@appTypes/esb/organizations/positions/_orgGuid';

import { CelKey } from '../constants';

// TODO: Everything in this file is for mock propuses, might be removed or not

export interface RosterAdultMemberExtended extends RosterAdultMember {
  userOrgPositions: OrgPositionDetail[];
}

// Unless is needed do not add flase rules, keep it simple
// Posiblre values:
// {isUnitRequired:true, isUnitEnabled:true, isSubRequired:true, isSubEnabled:true, isRecommended:true, cannotAssign:true}
export const PermsConfigurationObject = {
  'Chartered Organization Rep.': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { isUnitRequired: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  'Assistant Scoutmaster': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Unit Advancement Chair': {
    [CelKey.ACTIVITY_CREATE]: { isRecommended: true },

    [CelKey.ADVANCEMENT_AWARD]: { isRecommended: true },
    [CelKey.ADVANCEMENT_APROVE]: { isRecommended: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isRecommended: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Committee Chair': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  Scoutmaster: {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  'Council Unit Representative': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { isUnitRequired: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  'COR/CUR Delegate': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { isUnitRequired: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  'Key 3 Delegate': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  // Patrol support doesn't exist yet
  'Patrol Support': {
    [CelKey.ACTIVITY_CREATE]: { isSubRequired: true, isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isSubRequired: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  // Unit support doesn't exist yet
  'Unit Support': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  // Unit Merit Badge administrator doesn't exist yet
  'Unit Merit Badge administrator': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  // Calendar editor doesn't exist yet
  'Calendar Editor': {
    [CelKey.ACTIVITY_CREATE]: { isRecommended: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  // Unit Outdoors/Activities chair doesn't exist yet
  'Unit Outdoors/Activities chair': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Unit Treasurer': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'New Member Coordinator': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Unit Chaplain': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Unit Religious Emblems Coord': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  // COMMITTEE SECRETARY is the same as Secretary
  // Secretary doesn't exist yet
  Secretary: {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Unit Training Chair': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Youth Protection Champion': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Youth Member': {
    [CelKey.ACTIVITY_CREATE]: { cannotAssign: true },

    [CelKey.ADVANCEMENT_AWARD]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_APROVE]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_EDIT]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { cannotAssign: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitEnabled: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { cannotAssign: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Assistant Cubmaster': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isRecommended: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isRecommended: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  Cubmaster: {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  'Den Leader': {
    [CelKey.ACTIVITY_CREATE]: { isSubRequired: true, isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isSubRequired: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { cannotAssign: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { isSubRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  // Den Support doesn't exist yet
  'Den Support': {
    [CelKey.ACTIVITY_CREATE]: { isSubRequired: true, isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isSubRequired: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isSubRequired: true, isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { isSubRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  'Asst. Den Leader': {
    [CelKey.ACTIVITY_CREATE]: { cannotAssign: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isSubEnabled: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Committee Member': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isSubEnabled: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitEnabled: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Unit College Scouter Reserve': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isSubEnabled: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitEnabled: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Unit Scouter Reserve': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isSubEnabled: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitEnabled: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Venturing Crew Advisor': {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  Skipper: {
    [CelKey.ACTIVITY_CREATE]: { isUnitRequired: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitRequired: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitRequired: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitRequired: true },
    [CelKey.FINANCE_POCREATE]: { isUnitRequired: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitRequired: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { isUnitRequired: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { isUnitRequired: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitRequired: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitRequired: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { isUnitRequired: true },
  },
  'Venturing Crew Assoc. Advisor': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { isUnitEnabled: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitEnabled: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitEnabled: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitEnabled: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitEnabled: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  Mate: {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { isUnitEnabled: true },
    [CelKey.FINANCE_INDIVCREATE]: { isUnitEnabled: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { isUnitEnabled: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { isUnitEnabled: true },
    [CelKey.SUBUNIT_EDIT]: { isUnitEnabled: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Registration Inquiry': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitRequired: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitRequired: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitRequired: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Digital Product Sale Manager ': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { isUnitEnabled: true },

    [CelKey.CALENDAR_CREATE]: { isUnitEnabled: true, isSubEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitRequired: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Venturing College Sctr Reserve': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isSubEnabled: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitEnabled: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  'Executive Officer': {
    [CelKey.ACTIVITY_CREATE]: { isUnitEnabled: true },

    [CelKey.ADVANCEMENT_AWARD]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_APROVE]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_EDIT]: { isUnitEnabled: true },
    [CelKey.ADVANCEMENT_MBLIST]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SCOUT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_TENDERFOOT_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_SECONDCLASS_EDITOR]: { cannotAssign: true },
    [CelKey.ADVANCEMENT_FIRSTCLASS_EDITOR]: { cannotAssign: true },

    [CelKey.CALENDAR_CREATE]: { isSubEnabled: true, isUnitEnabled: true },

    [CelKey.FINANCE_CREATE]: { cannotAssign: true },
    [CelKey.FINANCE_INDIVCREATE]: { cannotAssign: true },
    [CelKey.FINANCE_POCREATE]: { isUnitEnabled: true },

    [CelKey.LEADERSHIP_ACCEPTANCE]: { cannotAssign: true },
    [CelKey.LEADERSHIP_APPROVE]: { cannotAssign: true },

    [CelKey.MEMBERSHIP_INACTIVE_YOUTH]: { cannotAssign: true },
    [CelKey.MEMBERSHIP_INACTIVE_ADULT]: { cannotAssign: true },

    [CelKey.MESSAGING_CREATE]: { isUnitEnabled: true },
    [CelKey.MESSAGING_GROPU_CREATE]: { isUnitEnabled: true },

    [CelKey.UNIT_PROFILE_EDIT]: { isUnitEnabled: true },
    [CelKey.UNIT_EDIT]: { cannotAssign: true },
    [CelKey.UNIT_REPORTS]: { isUnitRequired: true },
    [CelKey.SUBUNIT_CREATE]: { cannotAssign: true },
    [CelKey.SUBUNIT_EDIT]: { cannotAssign: true },
    [CelKey.SUBUNIT_DENCHIEF_ADD]: { cannotAssign: true },
  },
  // Not selectable positions:----------
  // Assistant Webelos Leader
  // Pack Trainer
  // Lion Guide
  // Tiger Den Leader
  // Webelos Leader
  // Lion Adult Partner
  // Tiger Cub Adult
};
